"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = _interopRequireDefault(require("react-jss"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Select = _interopRequireDefault(require("./Select.style"));
var _utils = _interopRequireDefault(require("../utils/utils"));
var _TextField = _interopRequireDefault(require("../TextField"));
var _Popover = _interopRequireDefault(require("../Popover"));
var _Menu = _interopRequireDefault(require("../Menu"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Button = _interopRequireDefault(require("../Button"));
var _SpacedLabel = _interopRequireDefault(require("../SpacedLabel"));
var _constants = require("../constants");
var _dec, _class;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let Select = (_dec = (0, _reactJss.default)(_Select.default), _dec(_class = class Select extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selected: false,
      activeTitle: null,
      prevValue: props.value,
      filter: null
    };
    this.handleMenuItemClick = this.handleMenuItemClick.bind(this);
    this.handleMenuClose = this.handleMenuClose.bind(this);
    this.handleTextFieldFocus = this.handleTextFieldFocus.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.txtElRef = _react.default.createRef();
  }
  static getDerivedStateFromProps({
    value,
    children
  }, {
    filter,
    prevValue
  }) {
    const stateUpdate = {
      activeTitle: value
    };
    if (value !== prevValue) {
      stateUpdate.prevValue = value;
      // reset filter if value is updated
      // but not if value is set via onInputChange, as in CDU select
      if (value !== filter) {
        stateUpdate.filter = null;
      }
    }
    if (!value || !value.length) {
      stateUpdate.activeTitle = null;
      return stateUpdate;
    }
    _react.default.Children.forEach(children, child => {
      const childValue = child.props.value || '';
      const childValueF = childValue.toString().toLowerCase();
      const valueF = value.toString().toLowerCase();
      if (childValueF === valueF) {
        stateUpdate.activeTitle = child.props.label;
      }
    });
    return stateUpdate;
  }
  handleMenuItemClick({
    value
  }) {
    let error = false;
    const {
      id,
      required
    } = this.props;
    if (required && typeof value === 'undefined') {
      error = true;
    }
    this.props.onChange({
      id,
      value,
      error
    });
    this.setState({
      selected: false
    });
  }
  handleTextFieldFocus() {
    this.setState({
      selected: true
    });
  }
  handleMenuClose() {
    this.setState({
      selected: false
    });
  }
  handleInputChange({
    value
  }) {
    let error = false;
    const {
      id,
      required
    } = this.props;
    if (required) {
      error = true;
    }
    this.props.onInputChange({
      id,
      value,
      error
    });
    this.setState({
      filter: value
    });
  }
  renderList() {
    const {
      filter
    } = this.state;
    const {
      children
    } = this.props;
    if (!children) return null;
    if (!filter) return children;
    const searchRegExp = _utils.default.escapeRegExp(filter.slice(0, 255));
    return _react.default.Children.toArray(children).filter(child => child.props.label.match(searchRegExp));
  }
  renderTextField({
    classes,
    label,
    tooltip,
    error,
    helperText,
    visibility,
    bordered,
    size,
    leftIcon,
    type,
    resettable,
    placeholder,
    autoSelect,
    onReset: _onReset,
    onClick,
    endAdornment,
    dataTestId,
    onFocus: _onFocus,
    endAdornmentBtnType
  }) {
    const {
      autoFocus
    } = this.props;
    const {
      activeTitle,
      filter,
      selected
    } = this.state;
    const value = selected ? filter !== null && filter !== void 0 ? filter : activeTitle : activeTitle;
    return /*#__PURE__*/_react.default.createElement(_TextField.default, {
      className: classes.edit,
      label: label,
      tooltip: tooltip,
      error: error,
      helperText: helperText,
      value: value,
      inputMode: type === 'autocomplete' ? 'text' : 'none',
      placeholder: placeholder,
      leftIcon: leftIcon,
      visibility: visibility,
      autoFocus: autoFocus,
      dataTestId: dataTestId,
      onFocus: (...args) => {
        if (onClick) {
          onClick(...args);
        }
        if (_onFocus) {
          _onFocus(...args);
        }
        this.handleTextFieldFocus(...args);
      },
      toggleFocus: true,
      onChange: this.handleInputChange,
      readOnly: type !== 'autocomplete',
      autoSelect: autoSelect,
      size: size,
      bordered: bordered,
      color: this.props.color,
      unspaced: this.props.unspaced,
      resettable: resettable,
      trimOnOutsideClick: false,
      onReset: (...args) => {
        this.handleMenuItemClick({
          value: null
        });
        if (_onReset) {
          _onReset(...args);
        }
      },
      endAdornment: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, endAdornment, /*#__PURE__*/_react.default.createElement(_Button.default, {
        type: endAdornmentBtnType,
        size: "xsmall",
        icon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
          type: "dropdown",
          error: error,
          size: "micro"
        })
      }))
    });
  }
  renderMenu({
    id,
    classes,
    visibility
  }) {
    const {
      selected
    } = this.state;
    if (visibility === 'disabled') return null;
    return /*#__PURE__*/_react.default.createElement(_Menu.default, {
      id: id,
      className: (0, _clsx.default)(classes.menu, {
        unspaced: this.props.unspaced
      }),
      onClick: this.handleMenuItemClick,
      onClose: this.handleMenuClose,
      onScroll: this.props.onMenuScroll,
      visibility: selected ? 'visible' : 'hidden',
      activeItem: this.props.value
    }, this.renderList());
  }
  render() {
    const {
      classes,
      id,
      className,
      visibility,
      type,
      label,
      tooltip,
      error,
      helperText,
      children,
      bordered,
      leftIcon,
      size,
      onReset,
      resettable,
      placeholder,
      autoSelect,
      endAdornment,
      dataTestId,
      onFocus,
      endAdornmentBtnType = 'text'
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: this.txtElRef,
      id: id,
      className: (0, _clsx.default)(className, classes.select),
      "data-testid": dataTestId ? `${dataTestId}-container` : undefined
    }, /*#__PURE__*/_react.default.createElement(_Popover.default, (0, _extends2.default)({
      content: this.renderMenu({
        id,
        classes,
        children,
        visibility
      }),
      bindingElementRef: this.txtElRef,
      className: classes.popover,
      anchors: {
        binding: _Popover.default.ANCHOR.left_bottom,
        content: _Popover.default.ANCHOR.left_top
      },
      fitToBindingElementWidth: true,
      verticalPlacingOnly: true,
      topLevel: this.props.popoverOnTop
    }, this.props.popoverOptions), ({
      onClick
    }) => this.renderTextField({
      classes,
      label,
      tooltip,
      error,
      helperText,
      visibility,
      bordered,
      size,
      leftIcon,
      type,
      placeholder,
      autoSelect,
      onClick,
      onReset,
      resettable,
      endAdornment,
      dataTestId,
      onFocus,
      endAdornmentBtnType
    })));
  }
}) || _class);
Select.Label = _SpacedLabel.default;
Select.COLOR = _utils.default.pick(_constants.COLOR, ['white']);
Select.defaultProps = {
  children: null,
  id: null,
  visibility: 'visible',
  error: false,
  bordered: false,
  type: 'default',
  onChange: () => {},
  onInputChange: () => {},
  onMenuScroll: () => {},
  popoverOptions: {}
};
var _default = exports.default = Select;